<app-store-navigation></app-store-navigation>

@if (storeId()) {
  <div>
    <div class="row mb-3">
      <div class="me-auto col-3">
        <div class="list-calendar-switch">
          <div [ngClass]="{'inactive': !isListPageActive(), 'active': isListPageActive()}">
            <a class="list pointer" (click)="setPage(pages.list)">List</a>
          </div>
          <div [ngClass]="{'inactive': isListPageActive(), 'active': !isListPageActive()}">
            <a class="calendar pointer" (click)="setPage(pages.availabilities)">Calendar</a>
          </div>
        </div>
      </div>
      @if (!isListPageActive()) {
        <div class="m-auto week-with-date col-6">
          <div class="week-number">Week {{ selectedMonday() | dateParse | dateFormat: 'WW' }}</div>
          <app-week-select
                  [selectedMonday]="selectedMonday()"
                  [latestMonday]="lastMonday"
                  (selectedMondayEvent)="selectWeek($event)">
          </app-week-select>
        </div>
      }
      @if (!isListPageActive()) {
        <div class="ms-auto text-end col-3">
          Show:
          <div ngbDropdown class="d-inline-block">
            <button class="btn btn-outline-secondary" id="page-dropdown" ngbDropdownToggle>{{ page() }}</button>
            <div ngbDropdownMenu aria-labelledby="page-dropdown">
              <button class="dropdown-item" ngbDropdownItem (click)="setPage(pages.availabilities)">Availabilities
              </button>
              <button class="dropdown-item" ngbDropdownItem (click)="setPage(pages.capabilities)">Capabilities</button>
            </div>
          </div>
        </div>
      }
    </div>
    @if (isListPageActive()) {
      <app-employees-list
              [storeId]="storeId()"
              [employees]="employees()">
      </app-employees-list>
    }
    @if (page() === pages.availabilities) {
      <app-employees-availabilities
              [storeId]="storeId()"
              [employees]="employees()"
              [selectedMonday]="selectedMonday()"
              [dates]="getDatesForSelectedWeek()"
              [availabilities]="availabilities()">
      </app-employees-availabilities>
    }
    @if (page() === pages.capabilities) {
      <app-employees-capabilities
              [storeId]="storeId()"
              [employees]="employees()"
              [selectedMonday]="selectedMonday()"
              [dates]="getDatesForSelectedWeek()">
      </app-employees-capabilities>
    }
  </div>
}
